import { render, staticRenderFns } from "./ModalVideo.vue?vue&type=template&id=6521f1ca&scoped=true"
import script from "./ModalVideo.vue?vue&type=script&lang=js"
export * from "./ModalVideo.vue?vue&type=script&lang=js"
import style0 from "./ModalVideo.vue?vue&type=style&index=0&id=6521f1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6521f1ca",
  null
  
)

export default component.exports